export const BMRTooltipComponent = () => (
  <div>
    Basal Metabolic Rate (BMR) is calculated using the Mifflin-St. Jeor Equation as follows:
    <br />
    Men: (10 x weight in kg) + (6.25 x height in cm) - (5 x age in years) + 5
    <br />
    Women: (10 x weight in kg) + (6.25 x height in cm) - (5 x age in years) - 161
  </div>
);
